module.exports = __webpack_public_path__ + "static/media/connectguide1.b658ded5.png";